// usePersistentCollapsed — gemerkter Ein-/Ausklapp-Zustand für Karten und
// Leisten. Lag bis zuletzt modul-privat in DashboardShared und war damit für die
// Speicherleiste der Kundenakte nicht nutzbar.

import { useCallback, useState } from "react";

/**
 * Ein-/Ausklapp-Zustand, der den Seitenwechsel überlebt: gemerkt wird unter
 * `key` im localStorage — '1' eingeklappt, '0' ausgeklappt. Ist der Speicher
 * nicht verfügbar (Privatmodus, gesperrte Cookies), bleibt der Zustand nur im
 * Arbeitsspeicher; die Bedienung darf daran nicht scheitern.
 *
 * `standard` greift ausschließlich, solange nichts gemerkt ist: Dashboard-Karten
 * stehen offen, die Speicherleiste der Kundenakte ruht eingeklappt.
 */
export function usePersistentCollapsed(key: string, standard = false): [boolean, () => void] {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      const gemerkt = window.localStorage.getItem(key);
      return gemerkt == null ? standard : gemerkt === "1";
    } catch {
      return standard;
    }
  });
  const toggle = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        window.localStorage.setItem(key, next ? "1" : "0");
      } catch {
        /* localStorage nicht verfügbar — Zustand bleibt nur in-memory */
      }
      return next;
    });
  }, [key]);
  return [collapsed, toggle];
}

export default usePersistentCollapsed;
